/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
 * software and associated documentation files (the "Software"), to deal in the Software
 * without restriction, including without limitation the rights to use, copy, modify,
 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
import { Component, OnInit, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {
  OidcSecurityService,
  PublicEventsService,
  EventTypes,
} from 'angular-auth-oidc-client';
import { tap, filter } from 'rxjs/operators';
import {AuthConfigurationService} from './views/auth/auth-configuration.service';
import { FIREBASE_REFERENCES } from './core/firebase/firebase.module';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';
import { PaymentService } from './payment/payment.service';

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet>',

})
export class AppComponent implements OnInit {
 
  readonly helloWorldOne$: Observable<{ [key: string]: any }>;
  readonly helloWorldTwo$: Observable<{ [key: string]: any }>;
  constructor(
   
    @Inject(FIREBASE_REFERENCES.TRADE_FIREDB) private readonly tradeDb: AngularFireDatabase,
    @Inject(FIREBASE_REFERENCES.MARCHE_FIREDB) private readonly marcheDb: AngularFireDatabase,
    private router: Router,
    public oidcSecurityService: OidcSecurityService,
    private eventService: PublicEventsService,
    private authConfigService: AuthConfigurationService
  ) {
    this.marcheDb.database.ref('P_Actives').once( 'value', data => {
        console.log(Object.values(data.val()))
    })
  }

  ngOnInit() {
    this.authConfigService.setOidcConfig();

    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
      }
        let token = localStorage.getItem('token')
        if (token == "") {
          // Perform logout
          //Navigate to login/home
            this.router.navigate(['/']);
           
        }}  

  ); 

    this.oidcSecurityService
      .checkAuth()
      .subscribe((isAuthenticated) => {
          console.log('app authenticated', isAuthenticated);

        }
      );

    this.eventService
      .registerForEvents()
      .pipe(
        tap((x) => console.log('Notif:', x)),
        filter(
          (notification) =>
            notification.type === EventTypes.CheckSessionReceived
        )
      )
      .subscribe((value) =>
        console.log('CheckSessionReceived with value from app', value)
      );

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    localStorage.setItem('Data', JSON.stringify({}))
    localStorage.setItem('DataOPCVM', JSON.stringify({}))







  }

}
